// extracted by mini-css-extract-plugin
module.exports = {"novaTarefa":"style_novaTarefa__2XfvE","inputContainer":"style_inputContainer__2HGsF"};